import { CloudDownload } from 'lucide-react';
import { Button } from '../ui/button';
import { DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { toast } from '../ui/toast/use-toast';
import { BankAccountTable } from './bank-account-table';
import { useBudgetId, useSyncAccountApi } from '@liquidbudget/common';

export const BankImportDialogTable = () => {
  const budgetId = useBudgetId();
  const { mutate: importAccount, isPending: isImporting } = useSyncAccountApi();

  const handleImport = () => {
    importAccount(
      { budgetId },
      {
        onSuccess: () => {
          toast({
            title: 'Success',
            description: 'Bank import completed successfully',
          });
        },
      },
    );
  };

  return (
    <DialogContent className="lg:max-w-[80vw]">
      <DialogHeader>
        <DialogTitle>Bank Import</DialogTitle>
      </DialogHeader>
      <DialogDescription className="space-y-2">
        <p className="hidden md:block">
          We check your linked accounts every hour for new transactions, but please be patient - most banks only update
          their records once per day.
        </p>
      </DialogDescription>
      <BankAccountTable />

      <div className="flex justify-end mt-2">
        <Button variant="warning" onClick={handleImport} isLoading={isImporting}>
          <CloudDownload className="mr-2 h-4 w-4" />
          Import Now
        </Button>
      </div>
    </DialogContent>
  );
};
